<template>
  <div class="row">
    <div class="col-lg-4 col-md-5">
      <user-card>

      </user-card>
    </div>
    <div class="col-lg-8 col-md-7">
      <div class="card" style="margin-top:10px">
            <div class="card-header">
              <h4 class="card-title">Bio</h4>
              <p class="category"></p>
            </div>
            <div class="card-content">
              <p style="font-size:17px">I’m currently a M.S. student at the University of Utah studying computational creativity. I’m interested in music AI and HCI, and how they can enable new forms of artistic expression and interaction. Before COVID, you would find me at your local coffee shop composing music, designing a new present idea, or coding my heart out. As of right now, you will find me online working out various research ideas or working on my hiking app (since hiking + music + coding = perfection).</p>
            </div>

            <div class="card-header">
              <h4 class="card-title">Contact</h4>
              <p class="category"></p>
            </div>
            <div class="card-content">
              <p style="font-size:17px">Have an awesome project idea but want someone to help you see it to fruition? Email me <a href = "mailto: michael.clemens@outlook.com">here</a> and let's see if we can collaborate together! :D</p>
            </div>


            <div class="card-header">
              <h4 class="card-title">Current Projects</h4>
              <p class="category"></p>
            </div>
            <div class="card-content">
              <ul style="font-size:15px">
                <li>Toward Collecting an Ethically Sourced Soundwalk Repository for Generative Art</li>
                <li>Exploring the Role of Explainability in Computational Creativity: A Human-Centered Study of Explanations within Collaboration Computational Co-Creativity</li>
                <li>Theramin (because my friend wanted one and I'm always down for teaching people electronics 🥰 )</li>
              </ul>
            </div>
          </div>
    </div>
  </div>
</template>

<script>
  import EditProfileForm from '../Pages/UserProfile/EditProfileForm.vue'
  import UserCard from '../Pages/UserProfile/UserCard.vue'
  import MembersCard from '../Pages/UserProfile/MembersCard.vue'

  export default {
    components: {
      EditProfileForm,
      UserCard,
      MembersCard
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Dashboard/Overview.vue